import { FormLabel, Grid } from '@mui/material';
import { withStyles } from '@mui/styles';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserProfile } from '../../../hooks/useUserProfile';
import { UserPersonalInfo } from '../../../stores/types/user.types';
import CustomTextField from '../../react-native-material-wrapper/text-field.component';
import { BackButtonHeader } from '../../ui-components/back-button-header.component';
import { ViewWrapper } from '../../ui-components/view-wrapper.component';
import ActionButton from '../action-button.component';
import { userStyles } from '../styles';
import { UserMode } from '../types/user-mode.enum';
import { ClassNameMap } from '@mui/styles';
import { showSnackBar } from '../../../util/toast.utility';
import { useLogger } from '../../../services/logging/logger-context';

interface IProps {
  setView: Function;
  currentUser: UserPersonalInfo;
  classes: ClassNameMap;
}

export const UserName = ({ classes, setView, currentUser }: IProps) => {
  const { i18n } = useTranslation();
  const [user, setUser] = useState(currentUser);
  const userProfile = useUserProfile();
  const { logger } = useLogger();
  const onClickBack = () => {
    setView(UserMode.NONE);
  };

  const onSave = async () => {
    try {
      await userProfile.updateUserName(user.given_name, user.family_name);
      setView(UserMode.NONE);
    } catch (e) {
      logger.error('Failed to update user name', e);
      showSnackBar(i18n.t('unknown_error'));
    }
  };

  const handleSaveValidation = () => {
    return !user.given_name || !user.family_name;
  };
  return (
    <ViewWrapper>
      <BackButtonHeader title={i18n.t('name')} onBackArrowClicked={onClickBack} />
      <Grid container className={classes.formWrapper}>
        <Grid xs={12} className={clsx(classes.paddingBottom8, classes.paddingTop)}>
          <Grid className={clsx(classes.paddingBottom8)}>
            <FormLabel htmlFor='first_name' className={clsx(classes.labelM)}>
              {i18n.t('first_name')}
            </FormLabel>
          </Grid>
          <CustomTextField
            id='first_name'
            className={clsx(classes.inputWrapper, classes.labelB2)}
            fullWidth
            value={user.given_name}
            onChange={(e) => setUser({ ...user, given_name: e.target.value })}
            variant='filled'
            required
            autoFocus
            InputProps={{ disableUnderline: true }}
          />
        </Grid>
        <Grid xs={12} className={clsx(classes.paddingBottom8, classes.paddingTop)}>
          <Grid className={clsx(classes.paddingBottom8)}>
            <FormLabel htmlFor='last_name' className={clsx(classes.labelM)}>
              {i18n.t('last_name')}
            </FormLabel>
          </Grid>
          <CustomTextField
            id='last_name'
            className={clsx(classes.inputWrapper, classes.labelB2)}
            fullWidth
            value={user.family_name}
            onChange={(e) => setUser({ ...user, family_name: e.target.value })}
            variant='filled'
            required
            InputProps={{ disableUnderline: true }}
          />
        </Grid>
      </Grid>
      <ActionButton label={i18n.t('save')} action={onSave} isDisabled={handleSaveValidation()} />
    </ViewWrapper>
  );
};

export default withStyles(userStyles)(UserName);
